import React from "react";
import { connect } from "react-redux";

class OpenPayModal extends React.Component {
    componentDidMount (){
        // setTimeout(() => {
        //     this.props.onClick()
        // }, 500);
    }
    render() {
        const { onClick = () => { }, DepositPayments } = this.props
        return (
            <>
                <div className='openPayModal' >
                    <div className='openPayModalCenter'>
                        <div className='openPayModalTitle' data-CN="存款">ฝากเงิน</div>
                        <div className="openPayModalBody">
                            รายการฝาก หมายเลขธุรกรรม {DepositPayments.transactionId || ""}<br/> 
                            สร้างเรียบร้อยแล้วคลิก "ตกลง" เพื่อเปิดหน้าต่างใหม่<br/> 
                            และดำเนินการฝากต่อไป
                        </div>
                        <div className="openPayModalBtn" onClick={onClick}>ตกลง</div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    DepositPayments: state.DepositPayments,
});
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(OpenPayModal);
